import React, { useState, useEffect } from "react";
import dogDictionary from "../db/dogDatabase";
import "./ResultChart.css";

function ResultChart({ result }) {
  const [topThree, setTopThree] = useState([]);

  useEffect(() => {
    const sortedResult = result.sort(
      (pre, cur) => cur.confidence - pre.confidence
    );
    const three = sortedResult.slice(0, 3);
    setTopThree(three);
    // console.log(three);
  }, [result]);

  return (
    <div className="resultChart">
      <ul className="ul-topThree">
        {topThree.map((dog, index) => (
          <li className="li-topThree" id={`topThree${index}`} key={dog.label}>
            <img
              className="img-li-topThree "
              src={`/dogImages/${dogDictionary[dog.label].imageUrl}`}
              alt="dogImage"
            />
            <div className="info-li-topThree">
              <div className="dogName-li-topThree">{dog.label}</div>
              <div className="percent-li-topThree">
                {dog.confidence.toString().slice(2, 4)}%
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ResultChart;
